"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _screenfull = _interopRequireDefault(require("screenfull"));
var _storage = require("@/utils/storage.js");
var _userNews = _interopRequireDefault(require("@/layout/navBars/breadcrumb/userNews.vue"));
var _search = _interopRequireDefault(require("@/layout/navBars/breadcrumb/search.vue"));
var _systemadmin = require("@/api/systemadmin");
var _merchant = require("@/api/merchant");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'layoutBreadcrumbUser',
  components: {
    UserNews: _userNews.default,
    Search: _search.default
  },
  data: function data() {
    return {
      isScreenfull: false,
      disabledI18n: 'zh-cn',
      disabledSize: '',
      label: {
        mer_name: 'admin'
      },
      isDot: true,
      // 站内消息是否显示小圆点
      messageList: [],
      // 站内消息列表
      messagePollingTimer: null,
      // 轮询定时器
      pollingInterval: 30000,
      // 轮询间隔(毫秒)，默认30秒
      consistencyStatus: null,
      consistencyPollingTimer: null,
      consistencyNotice: null,
      consistencyNoticeKey: '',
      dismissedConsistencyNoticeKeys: {}
    };
  },
  computed: {
    // 获取用户信息
    getUserInfos: function getUserInfos() {
      return this.$store.state.user;
    },
    // 设置弹性盒子布局 flex
    layoutUserFlexNum: function layoutUserFlexNum() {
      var _this$$store$state$th = this.$store.state.themeConfig.themeConfig,
        layout = _this$$store$state$th.layout,
        isClassicSplitMenu = _this$$store$state$th.isClassicSplitMenu;
      var num = '';
      if (layout === 'defaults' || layout === 'classic' && !isClassicSplitMenu || layout === 'columns') num = 1;else num = null;
      return num;
    },
    showConsistencyChecking: function showConsistencyChecking() {
      return Boolean(this.consistencyStatus && (this.consistencyStatus.scanInProgress || this.consistencyStatus.state === 'NEVER_RUN'));
    },
    showConsistencyAlert: function showConsistencyAlert() {
      return Boolean(this.consistencyStatus && !this.consistencyStatus.scanInProgress && ['INCONSISTENT', 'ERROR'].includes(this.consistencyStatus.state));
    },
    consistencyBadgeCount: function consistencyBadgeCount() {
      return this.consistencyStatus && this.consistencyStatus.issueCount > 99 ? '99+' : String(this.consistencyStatus && this.consistencyStatus.issueCount || 0);
    },
    consistencyAlertLabel: function consistencyAlertLabel() {
      if (!this.consistencyStatus) return '';
      var label = this.consistencyStatus.state === 'ERROR' ? "\u5546\u6237\u8D26\u53F7\u4E00\u81F4\u6027\u6821\u9A8C\u5931\u8D25\uFF0C\u4FDD\u7559 ".concat(this.consistencyStatus.recordCount || 0, " \u4E2A\u4E0D\u4E00\u81F4\u8BB0\u5F55") : "\u53D1\u73B0 ".concat(this.consistencyStatus.issueCount || 0, " \u4E2A\u5546\u6237\u8D26\u53F7\u6570\u636E\u4E0D\u4E00\u81F4\uFF0C\u67E5\u770B\u5546\u6237\u5217\u8868");
      var warning = this.orphanAdminWarning(this.consistencyStatus);
      return warning ? "".concat(label, "\uFF1B").concat(warning) : label;
    }
  },
  mounted: function mounted() {
    if (_storage.Local.get('JavaPlatThemeConfigPrev')) {
      this.initComponentSize();
    }
    this.getInternalPageInfo();
    // 启动轮询
    this.startMessagePolling();
    this.startConsistencyPolling();
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopMessagePolling();
    this.stopConsistencyPolling();
    this.closeConsistencyNotice();
  },
  methods: {
    // 搜索点击
    onSearchClick: function onSearchClick() {
      this.$refs.searchRef.openSearch();
    },
    // 布局配置点击
    onLayoutSetingClick: function onLayoutSetingClick() {
      this.bus.$emit('openSetingsDrawer');
    },
    refresh: function refresh() {
      this.bus.$emit('onTagsViewRefreshRouterView', this.$route.path);
    },
    // 全屏点击
    onScreenfullClick: function onScreenfullClick() {
      var _this = this;
      if (!_screenfull.default.isEnabled) {
        this.$message.warning('暂不不支持全屏');
        return false;
      }
      _screenfull.default.toggle();
      _screenfull.default.on('change', function () {
        if (_screenfull.default.isFullscreen) _this.isScreenfull = true;else _this.isScreenfull = false;
      });
      // 监听菜单 horizontal.vue 滚动条高度更新
      this.bus.$emit('updateElScrollBar');
    },
    // 初始化全局组件大小
    initComponentSize: function initComponentSize() {
      switch (_storage.Local.get('JavaPlatThemeConfigPrev').globalComponentSize) {
        case '':
          this.disabledSize = '';
          break;
        case 'medium':
          this.disabledSize = 'medium';
          break;
        case 'small':
          this.disabledSize = 'small';
          break;
        case 'mini':
          this.disabledSize = 'mini';
          break;
      }
    },
    // `dropdown 下拉菜单` 当前项点击
    onDropdownCommand: function onDropdownCommand(path) {
      var _this2 = this;
      if (path === 'logOut') {
        setTimeout(function () {
          _this2.$msgbox({
            closeOnClickModal: false,
            closeOnPressEscape: false,
            title: '提示',
            message: '此操作将退出登录, 是否继续?',
            showCancelButton: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
            beforeClose: function () {
              var _beforeClose = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(action, instance, done) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '退出中';
                        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                          return _regenerator().w(function (_context) {
                            while (1) switch (_context.n) {
                              case 0:
                                _context.n = 1;
                                return _this2.$store.dispatch('user/handleLogout');
                              case 1:
                                _this2.$router.push("/login?redirect=".concat(_this2.$route.fullPath));
                                done();
                              case 2:
                                return _context.a(2);
                            }
                          }, _callee);
                        })), 150);
                      } else {
                        done();
                      }
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
              function beforeClose(_x, _x2, _x3) {
                return _beforeClose.apply(this, arguments);
              }
              return beforeClose;
            }()
          }).then(function () {
            // 清除缓存/token等
            _storage.Session.clear();
            // 使用 reload 时，不需要调用 resetRoute() 重置路由
            window.location.reload();
          }).catch(function () {});
        }, 150);
      } else {
        this.$router.push("/operation/maintain/user/".concat(path));
      }
    },
    // 关闭站内消息popover
    closePopover: function closePopover() {
      this.$refs.messagePopover.doClose();
    },
    // 通过站内消息跳转页面
    goPage: function () {
      var _goPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(url) {
        var _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.closePopover();
              if (!url) {
                _context3.n = 4;
                break;
              }
              _context3.p = 1;
              _context3.n = 2;
              return this.$router.push(url);
            case 2:
              // 刷新页面
              this.refresh();
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              console.error('路由跳转失败:', _t);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function goPage(_x4) {
        return _goPage.apply(this, arguments);
      }
      return goPage;
    }(),
    // 开始轮询获取站内消息
    startMessagePolling: function startMessagePolling() {
      var _this3 = this;
      // 先清除已存在的定时器
      this.stopMessagePolling();

      // 设置定时器定期获取消息
      this.messagePollingTimer = setInterval(function () {
        _this3.internalRefresh();
      }, this.pollingInterval);
    },
    // 停止轮询
    stopMessagePolling: function stopMessagePolling() {
      if (this.messagePollingTimer) {
        clearInterval(this.messagePollingTimer);
        this.messagePollingTimer = null;
      }
    },
    startConsistencyPolling: function startConsistencyPolling() {
      if (!(0, _permission.checkPermi)(['platform:merchant:page:list'])) return;
      this.loadMerchantConsistency();
      this.consistencyPollingTimer = setInterval(this.loadMerchantConsistency, 600000);
    },
    stopConsistencyPolling: function stopConsistencyPolling() {
      if (this.consistencyPollingTimer) {
        clearInterval(this.consistencyPollingTimer);
        this.consistencyPollingTimer = null;
      }
    },
    loadMerchantConsistency: function () {
      var _loadMerchantConsistency = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t2, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _t2 = this;
              _context4.n = 1;
              return (0, _merchant.merchantConsistencyStatusApi)();
            case 1:
              _t2.applyConsistencyStatus.call(_t2, _context4.v);
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function loadMerchantConsistency() {
        return _loadMerchantConsistency.apply(this, arguments);
      }
      return loadMerchantConsistency;
    }(),
    applyConsistencyStatus: function applyConsistencyStatus(status) {
      var previousState = this.consistencyStatus && this.consistencyStatus.state;
      this.consistencyStatus = status;
      if (!status || status.scanInProgress || status.state === 'NEVER_RUN') return;
      if (status.state === 'HEALTHY') {
        this.closeConsistencyNotice();
        if (['INCONSISTENT', 'ERROR'].includes(previousState)) {
          this.$notify.success({
            title: '校验恢复',
            message: '商户账号一致性校验已恢复正常'
          });
        }
        return;
      }
      if (['INCONSISTENT', 'ERROR'].includes(status.state)) this.openConsistencyNotice(status);
    },
    consistencyNoticeIdentity: function consistencyNoticeIdentity(status) {
      return status.state === 'ERROR' ? "ERROR:".concat(status.signature || '', ":").concat(status.checkedAt || '') : "INCONSISTENT:".concat(status.signature || '');
    },
    openConsistencyNotice: function openConsistencyNotice(status) {
      var _this4 = this;
      var key = this.consistencyNoticeIdentity(status);
      if (key === this.consistencyNoticeKey || this.dismissedConsistencyNoticeKeys[key]) return;
      this.closeConsistencyNotice();
      var isError = status.state === 'ERROR';
      var notice;
      notice = this.$notify({
        title: isError ? '商户账号校验失败' : '商户账号数据异常',
        message: this.consistencyNoticeMessage(status),
        type: isError ? 'error' : 'warning',
        customClass: "merchant-consistency-notification merchant-consistency-notification--".concat(isError ? 'error' : 'warning'),
        duration: 0,
        showClose: true,
        onClose: function onClose() {
          return _this4.handleConsistencyNoticeClose(notice, key);
        }
      });
      this.consistencyNotice = notice;
      this.consistencyNoticeKey = key;
    },
    handleConsistencyNoticeClose: function handleConsistencyNoticeClose(notice, key) {
      if (this.consistencyNotice !== notice) return;
      this.dismissedConsistencyNoticeKeys[key] = true;
      this.consistencyNotice = null;
      this.consistencyNoticeKey = '';
    },
    closeConsistencyNotice: function closeConsistencyNotice() {
      var notice = this.consistencyNotice;
      this.consistencyNotice = null;
      this.consistencyNoticeKey = '';
      if (notice && typeof notice.close === 'function') notice.close();
    },
    orphanAdminWarning: function orphanAdminWarning(status) {
      return status && status.orphanAdminCount > 0 ? "\u53E6\u6709 ".concat(status.orphanAdminCount, " \u4E2A\u5B64\u7ACB\u7BA1\u7406\u5458\u9700\u6309\u8FD0\u7EF4\u8BF4\u660E\u6838\u9A8C") : '';
    },
    consistencyNoticeMessage: function consistencyNoticeMessage(status) {
      var _this5 = this;
      var isError = status.state === 'ERROR';
      var total = isError ? status.recordCount || 0 : status.issueCount || 0;
      var h = this.$createElement;
      var context = [];
      if (status.stale) context.push("\u4E0A\u6B21\u6210\u529F\uFF1A".concat(status.lastSuccessAt || '等待更新'));
      var warning = this.orphanAdminWarning(status);
      if (warning) context.push(warning);
      return h('div', {
        class: 'merchant-consistency-notice'
      }, [h('p', {
        class: 'merchant-consistency-notice__lead'
      }, isError ? '本次校验未完成，已保留最近一次可核验结果。' : '发现商户账号关系需要处理，请及时完成核验。'), h('div', {
        class: 'merchant-consistency-notice__facts'
      }, [h('div', {
        class: 'merchant-consistency-notice__fact merchant-consistency-notice__fact--metric'
      }, [h('strong', String(total)), h('span', isError ? ' 项记录已保留' : ' 项异常')]), h('div', {
        class: 'merchant-consistency-notice__fact merchant-consistency-notice__fact--time'
      }, [h('span', {
        class: 'merchant-consistency-notice__fact-label'
      }, '最近校验'), h('span', status.checkedAt || '等待校验结果')])]), context.length ? h('p', {
        class: 'merchant-consistency-notice__context'
      }, context.join('；')) : null, h('button', {
        class: 'merchant-consistency-notice__action',
        attrs: {
          type: 'button',
          'aria-label': '查看异常商户列表'
        },
        on: {
          click: function click(event) {
            if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
            _this5.openInconsistentMerchants();
          }
        }
      }, [h('span', '查看异常商户'), h('i', {
        class: 'el-icon-right',
        attrs: {
          'aria-hidden': 'true'
        }
      })])]);
    },
    openInconsistentMerchants: function openInconsistentMerchants() {
      this.$router.push({
        path: '/merchant/list',
        query: {
          consistencyOnly: 'true'
        }
      });
    },
    // 获取站内消息
    getInternalPageInfo: function () {
      var _getInternalPageInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var data, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _systemadmin.getInternalPageInfoApi)();
            case 1:
              data = _context5.v;
              this.messageList = data || [];
              this.isDot = this.messageList.length > 0;
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              console.error('获取站内消息失败:', _t4);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function getInternalPageInfo() {
        return _getInternalPageInfo.apply(this, arguments);
      }
      return getInternalPageInfo;
    }(),
    // 刷新站内消息
    internalRefresh: function () {
      var _internalRefresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return (0, _systemadmin.internalRefreshApi)();
            case 1:
              data = _context6.v;
              if (data) this.getInternalPageInfo();
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function internalRefresh() {
        return _internalRefresh.apply(this, arguments);
      }
      return internalRefresh;
    }()
  }
};